import React from 'react';
import { CookieBanner } from '@keepist/react-gdpr-cookie-banner';
import Cookies from 'universal-cookie';


const Footer = ({}) => {

    // Access the global domain based on the environment
    const domain = process.env.REACT_APP_DOMAIN_WORDPRESS; // Get domain from environment variable

  return (
    <footer className="bg-dark text-light py-4" id="hilfe">
      <div className="container d-flex justify-content-center footer-div">
        {/* Your footer content goes here */}
        <p>&copy; {new Date().getFullYear()} FIPA Wohnfinanzierung Vermittlungs-GmbH. | Seite erstellt von <a target="_blank" href="https://www.creativpuls.at">CreativPuls</a> | <a href={`${domain}/kontakt`} target="_blank">Impressum</a> | <a target="_blank" href={`${domain}/datenschutz`}>Datenschutz</a></p>
      </div>

      <CookieBanner
        message="Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung dieser Website stimmen Sie der Verwendung von Cookies zu."
        showPreferencesOption={false}
        showStatisticsOption={false}
        showMarketingOption={false}
        acceptAllButtonText="Cookies akzeptieren"
        necessaryOptionText="Notwendige Cookies"
        policyLink="https://www.wohnfinanzierung.at/datenschutz"
        privacyPolicyLinkText="Datenschutz"
        styles={{
          dialog: {
            position: 'fixed',
            bottom: '10px',
            left: '25%',
            width: '50%',
            backgroundColor: '#eaeaea',
            padding: '20px',
            borderRadius: '10px',
          },
          optionLabel: {
            color: '#000',
            paddingLeft: '25px',
          }
        }}
        onAccept = {() => {
          const domain = window.location.hostname; // Holt die aktuelle Domain
          document.cookie = `cookieAccept=1;max-age=604800;domain=${domain};path=/`;
        }}
      />
    </footer>

  );
};

export default Footer;
